(function(){
  "use strict";

  angular.module("modules.staticMap", [
    'modules.priceStartingAt',
    'modules.snapshotRange',
  ]);

})();